<template>
    <div class="wizard-steps-container">
        <div class="wizard-steps-prefix">
            Step {{ clampedStep }} of {{ maxSteps }}
        </div>
        <div class="wizard-steps">
            <div v-for="step in maxSteps" :key="step">
                <CompletedStep v-if="step < clampedStep" :size="size" />
                <CurrentStep v-else-if="step === clampedStep" :size="size" />
                <InCompleteStep v-else :size="size" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import InCompleteStep from './InCompleteStep.vue';
import CurrentStep from './CurrentStep.vue';
import CompletedStep from './CompletedStep.vue';

const props = defineProps({
    count_of_steps: {
        type: Number,
        required: true,
        validator: (value) => value >= 1 && value <= 10
    },
    current_step: {
        type: Number,
        required: true,
        validator: (value, props) => {
            if (value < 1 || value > 10) return false;
            if (!props) return true;
            return value <= props.count_of_steps;
        }
    },
    size: {
        type: String,
        default: 'large',
        validator: (value) => ['small', 'medium', 'large'].includes(value)
    },
})

const maxSteps = computed(() => Math.min(props.count_of_steps, 10))
const clampedStep = computed(() =>
  Math.min(Math.max(1, props.current_step), maxSteps.value)
)
</script>

<style scoped>
.wizard-steps-container {
    display: flex;
    gap: 12px;
}

.wizard-steps-prefix {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    color: #344054;
    display: flex;
    font-size: 14px;
    align-items: center;
    justify-content: center;
}

.wizard-steps {
    display: flex;
    gap: 12px;
}
</style>